import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Typography, Popover, Row, Col, Checkbox, Divider } from 'antd';
import SoloEventsTable from '../frontendForm/soloEventsTable/soloEventsTable';
import infoPDF from '../../TermsAndConditions/SACOPA Official Contestant - Information Package 2026.pdf';
import contractPDF from '../../TermsAndConditions/SACOPA Nationals - OFFICIAL CONTRACT 2026.pdf';

const ApplyEventsModal = ({
  visible,
  onClose,
  events,
  loading,
  openPopup,
  confirmLoading,
  userRole,
  handleDeleteEvent,
  onSelectEvent,
  selectedEvents,
  onApply,
  source,
  contestant,
  applications,
  group,
}) => {
  const [instrumentInputs, setInstrumentInputs] = useState({});
  const [infoAccepted, setInfoAccepted] = useState(false);
  const [contractAccepted, setContractAccepted] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalPDF, setModalPDF] = useState(null);

  const { Text } = Typography;

  useEffect(() => {
    const initialInstrumentInputs = {};
    selectedEvents.forEach((event) => {
      if (event.name === 'Instrumental') {
        initialInstrumentInputs[event._id] = event.instrument || '';
      }
    });
    setInstrumentInputs(initialInstrumentInputs);
  }, [selectedEvents]);

  useEffect(() => {
    if (!visible) {
      setInfoAccepted(false);
      setContractAccepted(false);
      setIsModalVisible(false);
      setModalPDF(null);
    }
  }, [visible]);

  const handleInstrumentChange = (eventId, value) => {
    setInstrumentInputs((prev) => ({ ...prev, [eventId]: value }));
  };

  const groupContent = (
    <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
      <Text style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '10px' }}>
        Entry fees for DUETS, TRIOS, SMALL GROUPS, LARGE GROUPS & PRODUCTION LINES are calculated
        per group entered.
      </Text>

      <Text strong style={{ marginTop: '10px', fontSize: '18px' }}>
        NOTE:
      </Text>

      <Text style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '10px' }}>
        Your GROUP MUST qualify for at least <strong>2 STYLES</strong> (open, hip hop,
        contemporary, gospel, dramatical, etc.) in your choice of EVENT (acting, dance,
        instrumentals, modelling, variety acts, and vocals) to qualify for the South Africa
        Championships of Performing Arts 2026.
      </Text>

      <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
        <li>
          <strong>DUET (2 x contestants)</strong> • R 790-00 per group • 4 STYLES ALLOWED
        </li>
        <li>
          <strong>TRIO (3 x contestants)</strong> • R 940-00 per group • 4 STYLES ALLOWED
        </li>
        <li>
          <strong>SMALL GROUP (4 - 9 contestants)</strong> • R 1130-00 per group • 4 STYLES
          ALLOWED
        </li>
        <li>
          <strong>LARGE GROUP (10 - 19 contestants)</strong> • R 1350-00 per group • 2 STYLES
          ALLOWED
        </li>
        <li>
          <strong>PRODUCTION LINE (20+ contestants)</strong> • R 1600-00 per group • 2 STYLES
          ALLOWED
        </li>
      </ul>
    </div>
  );

  const soloContent = (
    <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
      <Text style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '10px' }}>
        Entry fee for SOLO ENTRIES is calculated at <strong>R680-00 (incl VAT)</strong>. This ENTRY
        FEE allows you to enter a minimum of <strong>4 SOLO items</strong>. The items entered can be
        from <em>ANY EVENT</em> (acting, dance, instrumentals, modelling, variety acts, and vocals)
        and <em>ANY STYLE</em> (open, hip hop, contemporary, gospel, dramatical, etc.).
      </Text>

      <Text strong style={{ marginTop: '10px', fontSize: '18px' }}>
        NOTE:
      </Text>

      <Text style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '10px' }}>
        You MUST qualify for at least <strong>2 STYLES</strong> (open, hip hop, contemporary,
        gospel, dramatical, etc.) in your choice of EVENT (acting, dance, instrumentals, modelling,
        variety acts, and vocals) to qualify for the South Africa Championships of Performing Arts
        2026.
      </Text>

      <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
        <li>Make sure that you select the correct EVENTS and STYLES.</li>
        <li>
          The R680-00 (incl VAT) ENTRY FEE allows you to enter a minimum of 4 STYLES from ANY
          EVENT.
        </li>
        <li>
          You are allowed to enter for more than 2 STYLES (open, hip hop, contemporary, gospel,
          dramatical, etc.) per EVENT (acting, dance, instrumentals, modelling, variety acts, and
          vocals).
        </li>
        <li>
          Each ADDITIONAL STYLE (over and above the 4 minimum) will be{' '}
          <strong>R170-00 (incl VAT)</strong> per style EXTRA.
        </li>
      </ul>
    </div>
  );

  const nationalsContent = (
    <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
      <Text style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '10px' }}>
        <strong>Each contestant</strong> will pay a{' '}
        <strong>National Registration Fee of R2050.00 (incl VAT)</strong>. This fee includes
        registration and allows you to participate in <strong>up to 6 (six) styles</strong> in{' '}
        <em>any event</em> (acting, dance, instrumental, modelling, variety acts, vocal, and vocal
        self-accompaniment).
      </Text>

      <Text style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '10px' }}>
        For example: <strong>John Doe</strong> can enter for 2 x SOLO styles in the Vocal Event, 2 x
        SOLO styles in the Modelling Event, and 2 x GROUP styles in the Acting Event.
      </Text>

      <Text strong style={{ marginTop: '10px', fontSize: '18px' }}>
        NOTE:
      </Text>

      <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
        <li>
          The same applies to contestants entering <strong>only GROUP items</strong>—the R2050
          registration fee allows you to do 6 (six) styles in any group event.
        </li>
        <li>
          <strong>Extra Styles:</strong>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li>
              <strong>SOLO extra styles are unlimited</strong>. If you want to enter for more than 6
              styles in any event, each additional style is <strong>R280.00 (incl VAT)</strong> per
              style.
            </li>
            <li>
              <strong>GROUP extra styles are unlimited</strong>. If you want to enter for more than
              6 styles in any group event, each additional style is{' '}
              <strong>R280.00 (incl VAT)</strong> <em>per style per person in the group</em>.
            </li>
          </ul>
        </li>
        <li>Make sure you select the correct events and styles when registering.</li>
      </ul>
    </div>
  );

  let content = null;
  console.log(contestant);
  if (contestant?.round === 1 || group?.round === 1) {
    content = source === 'group' ? groupContent : soloContent;
  } else {
    content = nationalsContent;
  }

  const isModellingCommercialEvent = (ev) => {
    if (!ev) return false;

    const name = (ev.name || '').toString().toLowerCase().trim();
    const style = (ev.style || '').toString().toLowerCase();

    return name === 'modelling' && style.includes('commercial');
  };

  const isModellingPetitePlusEvent = (ev) => {
    if (!ev) return false;

    const name = (ev.name || '').toString().toLowerCase().trim();
    const style = (ev.style || '').toString().toLowerCase();

    return (
      name === 'modelling' &&
      (style.includes('petite') || style.includes('plus'))
    );
  };

  const filteredEvents = useMemo(() => {
    // Admin sees everything unfiltered
    if (userRole === 'admin') {
      return events;
    }

    let baseEvents = [];

    if (contestant) {
      // SOLO CONTESTANT LOGIC
      if (contestant.round === 1) {
        baseEvents = events;
      } else {
        const round1Apps = applications.filter(
          (app) => app.round === 1 && app.contestant?._id === contestant._id
        );

        const eventNameCounts = {};
        round1Apps.forEach((app) => {
          if (!app.event || !app.event.name) return;
          eventNameCounts[app.event.name] = (eventNameCounts[app.event.name] || 0) + 1;
        });

        baseEvents = events.filter((ev) => eventNameCounts[ev.name] >= 1);
      }

      // Extra RULES for SOLO contestants:
      // 1) Modelling + style containing "Commercial" → ONLY male, age >= 16
      // 2) Modelling + style containing "Petite" or "Plus" → ONLY female, age >= 16
      const gender = (contestant.gender || '').toString().toLowerCase();
      const age = Number(contestant.age || 0);
      const isMale16Plus = gender === 'male' && age >= 16;
      const isFemale16Plus = gender === 'female' && age >= 16;

      const filtered = baseEvents.filter((ev) => {
        if (isModellingCommercialEvent(ev) && !isMale16Plus) {
          return false;
        }

        if (isModellingPetitePlusEvent(ev) && !isFemale16Plus) {
          return false;
        }

        return true;
      });

      return filtered;
    }

    if (group) {
      // GROUP LOGIC – no additional Modelling restrictions here
      if (group.round === 1) {
        baseEvents = events;
      } else {
        const round1Apps = applications.filter(
          (app) => app.round === 1 && app.group?._id === group._id
        );

        const eventNameCounts = {};
        round1Apps.forEach((app) => {
          if (!app.event || !app.event.name) return;
          eventNameCounts[app.event.name] = (eventNameCounts[app.event.name] || 0) + 1;
        });

        baseEvents = events.filter((ev) => eventNameCounts[ev.name] >= 1);
      }

      return baseEvents;
    }

    return [];
  }, [userRole, contestant, group, events, applications]);

  return (
    <Modal
      title="Apply to Events"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Popover
          key="info"
          content={content}
          title="Entry Fee Information"
          trigger="click"
          placement="top"
          overlayStyle={{ width: '500px' }}
        >
          <Button type="link">View Entry Fee Info</Button>
        </Popover>,
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={confirmLoading}
          onClick={onApply}
          disabled={
            !(contestant?.round === 1 || group?.round === 1) &&
            (!infoAccepted || !contractAccepted)
          }
        >
          Apply
        </Button>,
      ]}
      width={800}
    >
      <SoloEventsTable
        events={filteredEvents}
        loading={loading}
        openPopup={openPopup}
        userRole={userRole}
        handleDeleteEvent={handleDeleteEvent}
        onSelectEvent={onSelectEvent}
        selectedEvents={selectedEvents}
      />

      {!(contestant?.round === 1 || group?.round === 1) && (
        <>
          <Divider />
          <Row align="left" style={{ flexDirection: 'column' }}>
            <Col>
              <Checkbox
                checked={infoAccepted}
                onChange={(e) => setInfoAccepted(e.target.checked)}
                style={{ marginBottom: 8 }}
              >
                I have read and accept the{' '}
                <Button
                  type="link"
                  onClick={() => {
                    setModalPDF(infoPDF);
                    setIsModalVisible(true);
                  }}
                  style={{ padding: 0 }}
                >
                  official contestant information package
                </Button>
              </Checkbox>
            </Col>
            <Col>
              <Checkbox
                checked={contractAccepted}
                onChange={(e) => setContractAccepted(e.target.checked)}
                style={{ marginBottom: 8 }}
              >
                I have read and accept the{' '}
                <Button
                  type="link"
                  onClick={() => {
                    setModalPDF(contractPDF);
                    setIsModalVisible(true);
                  }}
                  style={{ padding: 0 }}
                >
                  national official contract
                </Button>
              </Checkbox>
            </Col>
          </Row>
          <Divider />
        </>
      )}

      <Modal
        title="Document"
        open={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
        footer={
          <Button key="close" onClick={() => setIsModalVisible(false)}>
            Close
          </Button>
        }
        width={800}
      >
        {modalPDF && (
          <iframe
            src={modalPDF}
            width="100%"
            height="700px"
            style={{ border: 'none' }}
            title="PDF Document"
          />
        )}
      </Modal>
    </Modal>
  );
};

export default ApplyEventsModal;